module.exports = __webpack_public_path__ + "static/template_options_week_grid-daef5c8e52c90631f4ef19a355494615.png";